import { Component } from 'react';
import Loading from '../Loading';
import { noDataMessage } from '../../helpers/noDataMessage';

class ListData extends Component {
    constructor() {
        super();
    }

    render() {
        const barKey = this.props.keys.find((item) => item.bar);
        const columns = this.props.keys.filter((item) => !item.bar);

        return (
            <div
                className={`card rounded-main overflow-hidden list-data ${
                    this.props.cardClassName ?? ''
                }`}
                style={{ height: '100%' }}
            >
                {this.props.header && (
                    <div className="card-header list-data-header">
                        <div>
                            <div className="list-data-title">
                                {this.props.link ? (
                                    <a href={this.props.link}>
                                        <span>{this.props.header}</span>{' '}
                                        <i className="icon-arrow-right1 ml-8"></i>
                                    </a>
                                ) : (
                                    this.props.header
                                )}
                            </div>
                            {this.props.subheader && (
                                <div className="list-data-subheader">{this.props.subheader}</div>
                            )}
                        </div>
                        <div>
                            {this.props.forceRun && (
                                <div
                                    className="dt-exports d-flex justify-content-end w-100"
                                    title="Refresh and clear cache"
                                >
                                    <button
                                        className="dt-exports__button with-refresh"
                                        style={this.props.refreshCoustomStyles ?? {}}
                                        type="button"
                                        onClick={this.props.forceRun}
                                    >
                                        <i className="icon-Frame-converted"></i>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <div className="card-body">
                    {this.props.showError && this.props.customErrorMessage}
                    {!this.props.showError && this.props.loading && !this.props.loadMore && (
                        <Loading padding={10} />
                    )}
                    {!this.props.loading &&
                        (!this.props.data ||
                            (!this.props.data[0] &&
                                (this.props.customEmptyMessage || noDataMessage)))}
                    {!this.props.loading &&
                        this.props.data?.map((row) => {
                            return (
                                <div
                                    className={`list-data-item ${this.props.itemClassName ?? ''}`}
                                    key={row[this.props.uniqKey ?? 'id']}
                                >
                                    {columns.map((item) => (
                                        <div key={item.key} className={item.className}>
                                            {item.renderCell
                                                ? item.renderCell({
                                                      item: row,
                                                      data: row[item.key],
                                                      allData: this.props.data,
                                                  })
                                                : row[item.key]}
                                        </div>
                                    ))}
                                    {barKey && (
                                        <div
                                            className="list-data-bar"
                                            style={{
                                                width: `${barKey.renderCell({
                                                    item: row,
                                                    data: row[barKey.key],
                                                    allData: this.props.data,
                                                })}%`,
                                            }}
                                        ></div>
                                    )}
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    }
}

export default ListData;
